export default {
  璟馨: {
    fullname: '璟馨婦幼醫院',
    phone: '063023366',
    divisions: [
      '婦產科',
      '小兒科',
      '麻醉科',
      '乳房中心',
      '生殖醫學中心',
      '直腸外科',
    ],
    appointmentDivisions: [
      {
        division: '婦產科',
        notes: [
          '一般看診', '產檢(帶健保卡.孕婦手冊)',
        ],
      },
      {
        division: '小兒科',
        notes: [
          '一般看診', '打預防針(帶健保卡及兒童健康手冊)',
        ],
      },
      {
        division: '乳房外科',
        notes: [
          '一般看診',
        ],
      },
      {
        division: '乳房影像科',
        notes: [
          '一般看診', '乳房定期檢查', '乳房檢查（複檢/諮詢)',
        ],
      },
      {
        division: '生殖醫學科',
        notes: [
          '一般看診',
        ],
      },
      {
        division: '直腸外科',
        notes: [
          '一般看診',
        ],
      },
      {
        division: '女性泌尿科',
        notes: [
          '一般看診',
        ],
      },
    ],
  },
  詠馨: {
    fullname: '詠馨婦幼中心',
    phone: '062835888',
    divisions: [
      '婦產科',
      '家醫科',
      '小兒科',
      '麻醉科',
    ],
    appointmentDivisions: [
      {
        division: '婦產科',
        notes: [
          '一般看診', '產檢(帶健保卡.孕婦手冊)',
        ],
      },
      {
        division: '小兒科',
        notes: [
          '一般看診', '打預防針(帶健保卡及兒童健康手冊)',
        ],
      },
      {
        division: '乳房外科',
        notes: [
          '一般看診',
        ],
      },
      {
        division: '家醫科',
        notes: [
          '一般看診',
        ],
      },
    ],
  },
};
